import React from 'react';
import { Link } from 'react-router-dom';
import './Legalpages.css';

const Advertise = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Advertise With Us</h1>
        <p className="legal-last-updated">Reach Your Target Audience</p>

        <section className="legal-section">
          <h2>Why Advertise on FocusView.ai?</h2>
          <p>
            FocusView.ai attracts a highly engaged audience interested in cryptocurrency, artificial intelligence,
            and politics. Our readers are tech-savvy, forward-thinking professionals and enthusiasts who value
            quality information.
          </p>
        </section>

        <section className="legal-section">
          <h2>Our Audience</h2>
          <ul>
            <li><strong>Crypto Enthusiasts:</strong> Investors, traders, and blockchain professionals</li>
            <li><strong>Tech Professionals:</strong> AI researchers, developers, and technology leaders</li>
            <li><strong>Policy Makers:</strong> Political analysts, journalists, and engaged citizens</li>
            <li><strong>Early Adopters:</strong> Users who embrace cutting-edge technology and innovation</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Advertising Opportunities</h2>
          <p>
            We are currently building our advertising program and will offer various partnership opportunities
            including:
          </p>
          <ul>
            <li>Banner advertisements</li>
            <li>Sponsored content</li>
            <li>Newsletter sponsorships</li>
            <li>Custom partnership packages</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Get in Touch</h2>
          <p>
            Interested in advertising with FocusView.ai? We'd love to hear from you and discuss how we can
            help you reach your marketing goals.
          </p>
          <p>
            Contact our advertising team at: <a href="mailto:admin@focusview.ai">admin@focusview.ai</a>
          </p>
          <p>
            Please include "Advertising Inquiry" in the subject line, and tell us about your brand and
            advertising objectives.
          </p>
        </section>

        <div className="legal-navigation">
          <Link to="/contact" className="legal-link">Contact Us</Link>
          <Link to="/" className="legal-link">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Advertise;